import React, {useEffect, useState} from "react"
import {useParams} from "react-router-dom";
import BreadCrumb from "../../../Common/BreadCrumb";
import {useTranslation} from "react-i18next";
import {mockStores} from "../../../data/stores";
import {Card, Col, Container, Form, Row} from "react-bootstrap";
import {usersList} from "../../../data";
import {capitalizeFirstLetter} from "../../../utils/textUtils";


const StoreDetails = () => {
    const {id} = useParams();
    const {t} = useTranslation();
    const [store, setStore] = useState<Store | null>(null);

    useEffect(() => {
        const foundStore = mockStores.filter((store: Store) => store.id === id)[0];
        setStore(foundStore);
    }, [id])

    const getUserName = (userId: string) => {
        const mockUser = usersList.filter((user:any) => user.id === userId)[0];
        return mockUser.memberName;
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb
                        items={[
                            {label: t('Dashboard.header'), path: "/"},
                            {label: t('StoreList.page_title'), path: "/stores"},
                            {label: id as string, path: "/stores"},
                        ]}
                    />
                    <Card>
                        <Card.Body>
                            <h4 className="mb-4">{t('StoreList.store_details')}</h4>
                            {
                                store && (
                                    <Form>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="6" controlId="scenarioId">
                                                <Form.Label>{t('StoreList.store_id')}</Form.Label>
                                                <Form.Control type="text" value={store.id} disabled/>
                                            </Form.Group>

                                            <Form.Group as={Col} md="6" controlId="createdOn">
                                                <Form.Label>{t('StoreList.created_on')}</Form.Label>
                                                <Form.Control type="text" value={store.createdOn} disabled/>
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="scenarioName">
                                                <Form.Label>{t('StoreList.store_name')}</Form.Label>
                                                <Form.Control type="text" value={store.name} readOnly/>
                                            </Form.Group>


                                            <Form.Group className="mb-3" controlId="scenarioName">
                                                <Form.Label>{t('StoreList.city')}</Form.Label>
                                                <Form.Control type="text" value={capitalizeFirstLetter(store.city)} readOnly/>
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="scenarioName">
                                                <Form.Label>{t('StoreList.province')}</Form.Label>
                                                <Form.Control type="text" value={capitalizeFirstLetter(store.province)} readOnly/>
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="description">
                                                <Form.Label>{t('StoreList.address')}</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    value={store.address}
                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-3" controlId="scenarioName">
                                                <Form.Label>{t('StoreList.phone')}</Form.Label>
                                                <Form.Control type="text" value={store.phone} readOnly/>
                                            </Form.Group>

                                            <Form.Group controlId="activeStatus" className="mb-3">
                                                <Form.Label>{t('StoreList.active')}</Form.Label>
                                                <div>
                                                    <Form.Check
                                                        type="checkbox"
                                                        role="switch"
                                                        id="SwitchCheck9"
                                                        checked={store.active}/>
                                                </div>
                                            </Form.Group>

                                            <Form.Group>
                                                <Form.Label>{t('StoreList.user_list')}</Form.Label>
                                                {
                                                    store.users?.map((user:any) => (
                                                        <Form.Control type="text" value={getUserName(user)} readOnly/>
                                                    ))
                                                }
                                            </Form.Group>
                                        </Row>
                                    </Form>

                                )}
                        </Card.Body>
                    </Card>


                </Container>
            </div>
        </React.Fragment>
    )


}
export default StoreDetails;